/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["appearance-code-input{display:block}appearance-code-input>.code-input-container{flex:1 1 auto;display:flex;align-items:center;height:100%}appearance-code-input>.code-input-container>.change{color:#1565c0;font-size:1.3rem;margin-left:auto}"];
export { styles as styles };
